// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CursorArrowBigIconSignature {
  Element: SVGSVGElement;
}

export const CursorArrowBigIcon: TOC<CursorArrowBigIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.075 21.381C10.23 21.757 10.598 22 11 22C11.023 22 11.049 21.999 11.072 21.997C11.503 21.966 11.865 21.661 11.97 21.243L13.824 13.825L21.242 11.971C21.662 11.865 21.966 11.504 21.998 11.073C22.029 10.642 21.78 10.24 21.381 10.075L4.381 3.075C4.008 2.922 3.578 3.007 3.293 3.293C3.008 3.579 2.922 4.009 3.075 4.381L10.075 21.381ZM10.768 17.809L5.838 5.839L17.81 10.768L12.759 12.031C12.4 12.12 12.12 12.401 12.03 12.759L10.768 17.809Z"/>
</svg>
</template>;